import { Component, OnInit } from '@angular/core';

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-topbar-login',
  templateUrl: './topbar-login.component.html',
  styleUrls: ['./topbar-login.component.css']
})
export class TopbarLoginComponent implements OnInit {

  nombreSistema: string = environment.nombreSistema;

  constructor() { }

  ngOnInit(): void {
  }

}
